import { render, staticRenderFns } from "./TabelaNotaFiscal.vue?vue&type=template&id=a04a24e2&lang=pug"
import script from "./TabelaNotaFiscal.vue?vue&type=script&lang=js"
export * from "./TabelaNotaFiscal.vue?vue&type=script&lang=js"
import style0 from "./TabelaNotaFiscal.vue?vue&type=style&index=0&id=a04a24e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports